/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Type } from '@angular/core';

export class ComponentProvider {
  private static readonly componentTypes = new Map<string, Type<any>>();

  static registerComponentType(key: string, componentType: Type<any>) {
    this.componentTypes.set(key, componentType);
  }

  static resolveComponentType(key: string): Type<any> {
    if (!key) {
      return undefined;
    }
    return this.componentTypes.has(key) ? this.componentTypes.get(key) : null;
  }

}
